import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getCustomerRecords = createAsyncThunk(
  "get-record/getCustomerRecords",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/show-customer-record", payload);
      // console.log("The customer record api res is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getPaymentHistory = createAsyncThunk(
  "get-record/getPaymentHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/view-customer-payment-history",
        {
          service_provider_customer_id: payload.service_provider_customer_id,
        },
        {
          params: {
            
            page: payload.page || 1,
            start_date: payload.start_date,
            end_date: payload.end_date,
          },
        },
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const getOrderHistory = createAsyncThunk(
  "get-record/getOrderHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/view-customer-order-history",
        {
          service_provider_customer_id: payload.service_provider_customer_id,
        },
        {
          params: {
            
            page: payload.page || 1,
            start_date: payload.start_date,
            end_date: payload.end_date,
          },
        },
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const getBalanceHistory = createAsyncThunk(
  "get-record/getBalanceHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/view-customer-balance-sheet",
        {
          service_provider_customer_id: payload.service_provider_customer_id,
        },
        {
          params: {
            
            page: payload.page || 1,
            start_date: payload.start_date,
            end_date: payload.end_date,
          },
        },
      );
      // console.log("The customer balance sheet data is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const shareBalanceSheet = createAsyncThunk(
  "get-record/shareBalanceSheet",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/customer-balance-sheet-export",
        {
          service_provider_customer_id: payload.service_provider_customer_id,
        },
        {
          params: {
            
            page: payload.page || 1,
            start_date: payload.start_date,
            end_date: payload.end_date,
          },
        },
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const shareOrderSheet = createAsyncThunk(
  "get-record/shareOrderSheet",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/customer-order-export",
        {
          service_provider_customer_id: payload.service_provider_customer_id,
        },
        {
          params: {
            
            page: payload.page || 1,
            start_date: payload.start_date,
            end_date: payload.end_date,
          },
        },
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);
